// https://xxxxxx.execute-api.xxxxx.amazonaws.com/dev

export const API_BASE =
  process.env.REACT_APP_API_BASE ??
  "https://xxxxxx.execute-api.xxxxx.amazonaws.com/dev"; // À modifier

export const Labels = [
  "Très satisfait",
  "Satisfait",
  "Mécontent",
  "Très mécontent",
];
